import { module } from 'stereomodularjs';
import { html } from '../utils/environment'
import { createApp } from "vue/dist/vue.esm-bundler.js"

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.ids = [];
        this.el.querySelectorAll('.js-alert').forEach((el, index) => {
            this.ids.push(el.dataset.id);
        });
        let currentIds = this.ids.join(',');

        // Get cookie
        let alertShown = document.cookie.replace(/(?:(?:^|.*;\s*)alertShown\s*\=\s*([^;]*).*$)|^.*$/, "$1");

        // If alertShown is different from currentIds show the alert.
        if (alertShown !== currentIds) {
            document.documentElement.classList.add('is-banner-active');
        }

        eventAdd(this.el.querySelector('.js-close-alert'),'click', () => {
            document.documentElement.classList.remove('is-banner-active');
            // set cookie
            document.cookie = "alertShown=" + currentIds + "; path=/";
        });
    }
}